import { agreement } from "@/validation/";

const step8 = [];

const step8Validations = {};

export { step8Validations, step8 };
